/**
 * The sankey panel type and the settings it draws from.
 */

const sankey = {
  names: [
    {
      id: 'sankey',
      label: 'Sankey',
      phrase: 'a sankey diagram',
      guide: 'sankey.md',
      advanced: true,
      toolSummary: 'where a volume came from and where it ended up, one row per flow with its own already-aggregated total, capped at 24',
      promptSummary: 'where a volume came from and where it ended up, as ribbons whose thickness is the amount that moved, one row per flow with its own already-aggregated total, up to 24; one set of categories with no from-and-to is a bar chart instead',
      /* A sankey needs width for its layers and height for its bands, and neither is knowable from
         the rows, so the type asks for a shape once and stays freely resizable after. */
      creationLayout: { w: 6, h: 9 }
    }
  ],
  block: 'sankey',
  /* Sankey. The query already returns one row per flow; this block identifies the two ends of the
     ribbon and the amount that moved along it. There is no field for the node order or the ribbon
     thickness: the order is the rows' own, and the thickness is geometry. */
  fields: {
    sourceKey: { kind: 'string', required: true, hint: 'a flow needs both of its ends and an amount', label: 'Flow from' },
    targetKey: { kind: 'string', required: true, hint: 'a flow needs both of its ends and an amount', label: 'Flow to' },
    valueKey: { kind: 'string', required: true, hint: 'a flow needs both of its ends and an amount', label: 'Amount' },
    showLegend: { kind: 'boolean', default: true, label: 'Show legend' }
  },
  editorHint: 'One row is one flow: where it came from, where it ended up, and the amount that moved. The panel adds nothing up, so group each pair once in SQL, and keep the result to the flows that matter.',
  stateSummary: ({ block }) => (block.sourceKey && block.targetKey && block.valueKey ? `sankey: ${block.sourceKey} × ${block.targetKey} × ${block.valueKey}${block.showLegend === false ? ' · legend hidden' : ''}` : ''),
  toolSchema: {
    type: ['object', 'null'],
    additionalProperties: false,
    required: ['sourceKey', 'targetKey', 'valueKey'],
    description: 'Sankey mapping (displayType "sankey"): ONE ROW IS ONE FLOW between two labelled nodes, and its value is ALREADY AGGREGATED, so GROUP BY the pair in the source SQL and never send raw records. The same label is the same node wherever it appears, in either column, which is what chains A to B to C into more than two layers. A flow that runs back into somewhere the volume has already been has no layer to sit in, so it is counted below the diagram instead of drawn. Capped at 24 flows, with anything not drawn counted below the diagram. Read immutable/analytics/panel-types/sankey.md before configuring one.',
    properties: {
      sourceKey: { type: 'string', description: 'Column naming where the flow comes from. Dot paths work.' },
      targetKey: { type: 'string', description: 'Column naming where the flow ends up. Dot paths work.' },
      valueKey: { type: 'string', description: 'Column holding the positive numeric amount that moved along this flow. Dot paths work. An empty, non-numeric, zero, or negative amount has no ribbon to draw and is counted as not shown.' },
      showLegend: { type: 'boolean', description: 'Whether the legend naming each node appears under the diagram. Defaults true. Set false when the user asks for the legend gone; the nodes stay named on the diagram itself and in the hover card.' }
    }
  }
};

export default sankey;
